const _BASE_API_URL = import.meta.env.VITE_API_URL
const API_URL = _BASE_API_URL + ''

// AUTH
export const REQUEST_MAGIC_LINK_URL = API_URL + '/auth/magic-link/send'
export const LOGIN_URL = API_URL + '/auth/login'
export const LOGOUT_URL = API_URL + '/auth/logout'
export const LOGGED_USER_URL = API_URL + '/auth/me'

export const JOB_URL = API_URL + '/jobs'
export const COMPANY_URL = API_URL + '/companies'
export const EMPLOYEE_URL = API_URL + '/employees'
export const FORM_URL = API_URL + '/forms'
export const CAMPAIGN_URL = API_URL + '/campaigns'
export const CAMPAIGN_EMPLOYEE_URL = API_URL + '/campaign-employees'
export const CAMPAIGN_EMPLOYEE_MANAGER_URL =
  API_URL + '/manager/campaign-employees'

export const HOME_STATS_URL = API_URL + '/home/stats'
